import { Tooltip, TooltipContent, TooltipTrigger } from "@aircall/ds";
import { Info, Smile } from "@aircall/react-icons";

import { Feedbacks } from "@/blocks/Feedbacks/Feedbacks";
import { Section } from "@/blocks/Section/Section";

function noop() {}

export function PlaygroundSectionSentiment() {
  return (
    <Section data-test="customer-mood-card">
      <div className="flex items-center gap-1">
        <span className="text-sm font-semibold">Customer mood</span>
        <Tooltip>
          <TooltipTrigger render={<div data-test="customer-mood-info" />}>
            <Info className="size-4" />
          </TooltipTrigger>
          <TooltipContent side="top" align="center">
            How the customer felt during the call.
          </TooltipContent>
        </Tooltip>
      </div>
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-1">
          <Smile className="size-4 text-primary" />
          <span className="text-xs font-semibold text-muted-foreground">
            Positive
          </span>
        </div>
        <Feedbacks onClickThumbUp={noop} onClickThumbDown={noop} />
      </div>
    </Section>
  );
}
